export default "__VITE_ASSET__dce3cdd7__"